import React from 'react';
import dayjs from 'dayjs';
import { Box, DatePicker, Flex, Icon, Text } from '@singita/components';
import { isEqual } from 'lodash';
const Dates = ({
  form,
  setDates,
  colorScheme,
  showDates = false,
  errors = {},
  addShadow = false,
}) => {
  const { startDate, endDate } = form;

  let isOutsideRange = (date) => false;
  let _startDate;
  let _endDate;

  if (form.lodges && isEqual(form.lodges, ['TZG-SM'])) {
    isOutsideRange = { before: new Date('2024-05-16') };
  }
  //Elela opening on 1 Sept 2026
  if (form.lodges && isEqual(form.lodges, ['BSOD-EL'])) {
    isOutsideRange = { before: new Date('2026-09-01') };
  }
  return (
    <Flex
      sx={{
        height: '350px',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'start',
      }}
    >
      {showDates && (
        <Flex
          sx={{
            display: 'inline-flex !important',
            gap: '20px',
            marginBottom: '10px',
            border: '1px solid #dbdbdb;',
            padding: '10px',
          }}
        >
          <Text size="body" color="textLight">
            {dayjs(form.startDate).format('YYYY-MM-DD')}
          </Text>
          <Icon name="arrow-right" size="small" color="textLight" />
          <Text size="body" color="textLight">
            {dayjs(form.endDate).isValid()
              ? dayjs(form.endDate).format('YYYY-MM-DD')
              : 'End Date'}
          </Text>
        </Flex>
      )}
      <Box
        sx={
          addShadow
            ? {
                padding: '10px 20px',
                display: 'inline-block',
                boxShadow:
                  '0 12px 17px 2px rgba(0, 0, 0, 0.05),0 5px 22px 4px rgba(0, 0, 0, 0.06),0 7px 8px 0 rgba(0, 0, 0, 0.07)',
                borderRadius: '4px',
              }
            : {}
        }
      >
        <DatePicker
          startDate={_startDate || startDate}
          endDate={_endDate || endDate}
          setDates={(dates) => setDates(dates)}
          colorScheme={colorScheme}
          variant="minimal"
          isOutsideRange={isOutsideRange}
          showDates
        />
      </Box>
      <Flex flexDirection="column">
        {errors.startDate ? (
          <Text color="statusError" size="small">
            Please enter a start date.
          </Text>
        ) : null}
        {errors.endDate ? (
          <Text color="statusError" size="small">
            Please enter an end date.
          </Text>
        ) : null}
      </Flex>
    </Flex>
  );
};

export default Dates;
